import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div style={styles.body}>
      <div style={styles.container}>

        <div style={styles.header}>
          <div style={styles.appName}>Checkbook by arvada.io</div>
          <h1 style={styles.h1}>Privacy Policy</h1>
          <div style={styles.date}>Last updated: April 2026</div>
        </div>

        <div style={styles.highlightBox}>
          <p style={styles.highlightText}>
            Checkbook by arvada.io does not collect, store, or share any personal data. 
            All data entered into the app is stored locally on your device and is never 
            transmitted to any server.
          </p>
        </div>

        <section style={styles.section}>
          <h2 style={styles.h2}>Data Collection</h2>
          <p style={styles.p}>
            We do not collect any personal information. The app does not require account 
            registration, does not connect to the internet, and does not transmit any data 
            outside of your device.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.h2}>Data Storage</h2>
          <p style={styles.p}>
            All financial records, account information, and transaction data you enter are 
            stored exclusively on your device using Apples Core Data framework. This data 
            remains entirely under your control and is never accessible to us.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.h2}>Third Party Services</h2>
          <p style={styles.p}>
            This app does not integrate with any third party analytics, advertising, or 
            tracking services.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.h2}>Childrens Privacy</h2>
          <p style={styles.p}>
            This app does not collect data from any users, including children under the 
            age of 13.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.h2}>Changes to This Policy</h2>
          <p style={styles.p}>
            If our privacy practices change, we will update this page with a new effective 
            date. Continued use of the app after any changes constitutes acceptance of the 
            updated policy.
          </p>
        </section>

        <div style={styles.contact}>
          <h2 style={styles.h2}>Contact</h2>
          <p style={styles.p}>
            Questions about this privacy policy can be directed to{' '}
            <a href="mailto:bpstrad@gmail.com" style={styles.link}>bpstrad@gmail.com</a>
            {' '}or via{' '}
            <a href="https://arvada.io" style={styles.link}>arvada.io</a>.
          </p>
        </div>

        <div style={styles.footer}>© 2026 arvada.io — All rights reserved</div>

      </div>
    </div>
  );
};

const styles = {
  body: {
    fontFamily: "'Georgia', serif",
    color: '#2a2520',
    minHeight: '100vh',
    padding: '48px 24px',
  },
  container: {
    maxWidth: '680px',
    margin: '0 auto',
  },
  header: {
    borderBottom: '2px solid #2a2520',
    paddingBottom: '24px',
    marginBottom: '40px',
  },
  appName: {
    fontSize: '13px',
    fontWeight: '600',
    letterSpacing: '0.15em',
    textTransform: 'uppercase',
    color: '#8a7a6a',
    marginBottom: '12px',
  },
  h1: {
    fontSize: '36px',
    fontWeight: '400',
    lineHeight: '1.2',
    color: '#2a2520',
    margin: 0,
  },
  date: {
    marginTop: '12px',
    fontSize: '13px',
    color: '#8a7a6a',
    fontStyle: 'italic',
  },
  highlightBox: {
    background: '#2a2520',
    color: '#f7f4ef',
    padding: '24px 28px',
    marginBottom: '40px',
    borderRadius: '2px',
  },
  highlightText: {
    fontSize: '16px',
    lineHeight: '1.7',
    fontWeight: '300',
    margin: 0,
  },
  section: {
    marginBottom: '36px',
  },
  h2: {
    fontSize: '20px',
    fontWeight: '600',
    marginBottom: '12px',
    color: '#2a2520',
  },
  p: {
    fontSize: '16px',
    lineHeight: '1.8',
    color: '#4a3f35',
    fontWeight: '300',
    margin: 0,
  },
  contact: {
    borderTop: '1px solid #d4cdc4',
    paddingTop: '28px',
    marginTop: '40px',
  },
  link: {
    color: '#2a2520',
    textDecoration: 'underline',
    textUnderlineOffset: '3px',
  },
  footer: {
    marginTop: '48px',
    textAlign: 'center',
    fontSize: '12px',
    color: '#8a7a6a',
    letterSpacing: '0.1em',
    textTransform: 'uppercase',
  },
};

export default PrivacyPolicy;